import React from 'react';
import './styles/Navbar.css';
import logo from '../assets/blue-green-logo.png'; // adjust the path if your file is elsewhere

const Navbar = () => {
  return (
    <nav className="navbar">
      <div className="navbar-logo">
        <img src={logo} alt="Movingbay Logo" className="logo-img" />
      </div>
      <ul className="navbar-menu">
        <li className="navbar-item">Home</li>
        <li className="navbar-item">About</li>
        <li className="navbar-item">Why MovingBay</li>
        <li className="navbar-item">International Moving</li>
        <li className="navbar-item">Become a Partner</li>
      </ul>
      <a
        href="https://wa.me/918618173141"
        className="navbar-quote-btn"
        target="_blank"
        rel="noopener noreferrer"
      >
        <span>Request a Quote</span>
      </a>
    </nav>
  );
};

export default Navbar;
